// extracted by mini-css-extract-plugin
export default {"yandexMap":"ContactsMap_yandexMap__tB4Nu","loadingMapWrapper":"ContactsMap_loadingMapWrapper__QB2iH"};